import { ControlDocumentCarrier } from '../control-document-carrier';

export class ControlDocumentCarrierBuilder {

  static fromJson(json): ControlDocumentCarrier {
    return (json) ? new ControlDocumentCarrier(
      json.defaultControlDocumentCarrier,
    ) : null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/control-document-carrier.builder.ts